import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=6f88f6e4&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"
import style0 from "./SignUp.vue?vue&type=style&index=0&id=6f88f6e4&prod&scoped=true&lang=css"
import style1 from "./SignUp.vue?vue&type=style&index=1&id=6f88f6e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f88f6e4",
  null
  
)

export default component.exports